/**
 * TMDB (The Movie Database) API Servisi
 * Film posterlerini ve detaylarını çekmek için kullanılır
 */

const TMDB_BASE_URL = 'https://api.themoviedb.org/3';
const TMDB_IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/w500'; // Optimize edilmiş boyut (hızlı yükleme için w500)
const TMDB_IMAGE_BASE_URL_ORIGINAL = 'https://image.tmdb.org/t/p/original'; // En yüksek çözünürlük
const TMDB_IMAGE_BASE_URL_LOW = 'https://image.tmdb.org/t/p/w185'; // Düşük çözünürlük (blur placeholder için)
const DEFAULT_POSTER_URL = 'https://via.placeholder.com/400x600/6366f1/ffffff?text=Film+Posteri';

// Türkçe-İngilizce film adı çeviri tablosu
const TURKISH_TO_ENGLISH_MOVIES = {
    // Popüler filmler - Türkçe adlardan İngilizce karşılıklarına
    'kara şövalye': 'The Dark Knight',
    'yüzüklerin efendisi': 'The Lord of the Rings',
    'yüzüklerin efendisi: yüzük kardeşliği': 'The Lord of the Rings: The Fellowship of the Ring',
    'yüzüklerin efendisi: iki kule': 'The Lord of the Rings: The Two Towers',
    'yüzüklerin efendisi: kralın dönüşü': 'The Lord of the Rings: The Return of the King',
    'hobbit': 'The Hobbit',
    'esaretin bedeli': 'The Shawshank Redemption',
    'baba': 'The Godfather',
    'başlangıç': 'Inception',
    'matrix': 'The Matrix',
    'yıldızlararası': 'Interstellar',
    'yıldızlar arası': 'Interstellar',
    'ucuz roman': 'Pulp Fiction',
    'iyi adamlar': 'Goodfellas',
    'parazit': 'Parasite',
    'yenilmezler: son oyun': 'Avengers: Endgame',
    'aşk diyarı': 'La La Land',
    'büyük budapeşte oteli': 'The Grand Budapest Hotel',
    'çılgın max: öfke yolu': 'Mad Max: Fury Road',
    'aşk': 'Her',
    'demir adam': 'Iron Man',
    'örümcek adam': 'Spider-Man',
    'yenilmezler': 'The Avengers',
    'kaptan amerika': 'Captain America',
    'thor': 'Thor',
    'dövüş kulübü': 'Fight Club',
    'yeşil mil': 'The Green Mile',
    'kuzuların sessizliği': 'The Silence of the Lambs',
    'terminatör': 'The Terminator',
    'yıldız savaşları': 'Star Wars',
    'jurassic park': 'Jurassic Park',
    'titanik': 'Titanic',
    'forrest gump': 'Forrest Gump',
    'schindlerin listesi': "Schindler's List",
    'gladyatör': 'Gladiator',
    'lord of war': 'Lord of War',
    'casino': 'Casino',
    'scarface': 'Scarface',
    'taxi driver': 'Taxi Driver',
    'raging bull': 'Raging Bull',
    'django': 'Django Unchained',
    'kill bill': 'Kill Bill',
    'rezervuar köpekleri': 'Reservoir Dogs',
    'kaplan pençesi': 'Crouching Tiger, Hidden Dragon',
    'avatar': 'Avatar',
    'buz devri': 'Ice Age',
    'shrek': 'Shrek',
    'nemo': 'Finding Nemo',
    'karayip korsanları': 'Pirates of the Caribbean',
    'transformers': 'Transformers',
    'hızlı ve öfkeli': 'Fast & Furious',
    'james bond': 'James Bond',
    'indiana jones': 'Indiana Jones',
    'harry potter': 'Harry Potter',
    // Bilim kurgu filmleri
    'bıçak sırtı 2049': 'Blade Runner 2049',
    'bıçak sırtı': 'Blade Runner',
    'duin': 'Dune',
    'yapay': 'Ex Machina',
    'geliş': 'Arrival',
    'yer çekimi': 'Gravity',
    'yaratık': 'Alien',
    'geleceğe dönüş': 'Back to the Future',
    'marslı': 'The Martian',
    'hazır oyuncu bir': 'Ready Player One',
    'akil oyunları': 'A Beautiful Mind',
    'minority report': 'Minority Report',
    'total recall': 'Total Recall',
    'i robot': 'I, Robot',
    'elysium': 'Elysium',
    'oblivion': 'Oblivion',
    'edge of tomorrow': 'Edge of Tomorrow',
    'looper': 'Looper',
    'looper: gelecekten kaçış': 'Looper',
    'yarının sınırında': 'Edge of Tomorrow',
    'azınlık raporu': 'Minority Report',
    'toplam hatırlama': 'Total Recall',
    'ben robot': 'I, Robot',
    '9. bölge': 'District 9',
    'kaynak kod': 'Source Code',
    'ay': 'Moon',
    'gattaca': 'Gattaca',
    'yapay zeka': 'A.I. Artificial Intelligence',
    'dünyalar savaşı': 'War of the Worlds',
    'bağımsızlık günü': 'Independence Day',
    // Aksiyon filmleri
    'john wick': 'John Wick',
    'imkansız görev': 'Mission: Impossible',
    'zor ölüm': 'Die Hard',
    'baskın': 'The Raid',
    '300 spartalı': '300',
    'casino royale': 'Casino Royale',
    'the bourne identity': 'The Bourne Identity',
    'taken': 'Taken',
    'speed': 'Speed',
    'lethal weapon': 'Lethal Weapon',
    'rambo': 'Rambo',
    'predator': 'Predator',
    'commando': 'Commando',
    // Romantik filmler
    'defter': 'The Notebook',
    'kazablanka': 'Casablanca',
    'gurur ve önyargı': 'Pride and Prejudice',
    'gün doğmadan': 'Before Sunrise',
    'sonsuz güneş': 'Eternal Sunshine of the Spotless Mind',
    'hayalet': 'Ghost',
    'güzel kadın': 'Pretty Woman',
    'dirty dancing': 'Dirty Dancing',
    'when harry met sally': 'When Harry Met Sally',
    'sleepless in seattle': 'Sleepless in Seattle',
    'you\'ve got mail': 'You\'ve Got Mail',
    'jerry maguire': 'Jerry Maguire',
    // Korku filmleri
    'korkunç çağrı': 'The Conjuring',
    'kaç': 'Get Out',
    'kalıtsal': 'Hereditary',
    'şeytan': 'The Exorcist',
    'cadılar bayramı': 'Halloween',
    'çığlık': 'Scream',
    'sessiz yer': 'A Quiet Place',
    'o': 'It',
    'midsommar': 'Midsommar',
    'us': 'Us',
    'sinister': 'Sinister',
    'insidious': 'Insidious',
    // Komedi filmleri
    'hangover': 'The Hangover',
    'süper kötü': 'Superbad',
    'borat': 'Borat',
    'zoolander': 'Zoolander',
    'çapa adam': 'Anchorman',
    'üvey kardeşler': 'Step Brothers',
    'nedimeler': 'Bridesmaids',
    'tropic thunder': 'Tropic Thunder',
    'dodgeball': 'Dodgeball',
    'wedding crashers': 'Wedding Crashers',
    // Türk filmleri
    'babam ve oğlum': 'My Father and My Son',
    'ayla': 'Ayla',
    'eskiya': 'The Bandit',
    'gemide': 'On Board',
    'vizontele': 'Vizontele',
    'hababam sınıfı': 'The Chaos Class',
    'neşeli günler': 'Happy Days',
    'süt kardeşler': 'Foster Brothers',
    'kapıcılar kralı': 'King of Doormen',
    'arabesk': 'Arabesk',
    'gora': 'Gora',
    'arog': 'Arog',
    // Türk dizileri için eklemeler
    'eşkıya dünyaya hükümdar olmaz': 'Eşkıya Dünyaya Hükümdar Olmaz',
    'kara para aşk': 'Kara Para Aşk',
    'diriliş ertuğrul': 'Diriliş: Ertuğrul',
    'kuruluş osman': 'Kuruluş: Osman',
    'muhteşem yüzyıl': 'Muhteşem Yüzyıl',
    'muhteşem yüzyıl: kösem': 'Muhteşem Yüzyıl: Kösem',
    'kara sevda': 'Kara Sevda',
    'çukur': 'Çukur',
    'behzat ç': 'Behzat Ç',
    'medcezir': 'Medcezir',
    'kurtlar vadisi': 'Kurtlar Vadisi',
    'kurtlar vadisi pusu': 'Kurtlar Vadisi Pusu',
    'aşk-ı memnu': 'Aşk-ı Memnu',
    'doktorlar': 'Doktorlar',
    'kasaba': 'Kasaba',
    'arsız bela': 'Arsız Bela',
    'sıfır bir': 'Sıfır Bir',
    'içerde': 'İçerde',
    'çalıkuşu': 'Çalıkuşu'
};

// İngilizce-Türkçe çeviri tablosu (ters çeviri için)
const ENGLISH_TO_TURKISH_MOVIES = {};
Object.entries(TURKISH_TO_ENGLISH_MOVIES).forEach(([turkish, english]) => {
    ENGLISH_TO_TURKISH_MOVIES[english.toLowerCase()] = turkish;
});

/**
 * Film adını İngilizce'ye çevirir (TMDB araması için)
 * @param {string} turkishTitle - Türkçe film adı
 * @returns {string} İngilizce film adı veya orijinal
 */
const translateToEnglish = (turkishTitle) => {
    const lowerTitle = turkishTitle.toLowerCase().trim();
    return TURKISH_TO_ENGLISH_MOVIES[lowerTitle] || turkishTitle;
};

/**
 * TMDB API anahtarını kontrol eder
 * @returns {string} API anahtarı
 * @throws {Error} API anahtarı bulunamazsa hata fırlatır
 */
const getApiKey = () => {
    // .env dosyasından almaya çalış
    let apiKey = null;

    // Güvenli şekilde environment variable'ı kontrol et
    if (import.meta && import.meta.env && import.meta.env.VITE_TMDB_API_KEY) {
        apiKey = import.meta.env.VITE_TMDB_API_KEY;
    }

    // Eğer .env'de yoksa veya erişilemiyorsa hardcode anahtarı kullan
    if (!apiKey) {
        apiKey = '6896d2a6e0b1a73d05df1091f6be5bed';
    }

    if (!apiKey) {
        throw new Error('TMDB API anahtarı bulunamadı. .env dosyasında VITE_TMDB_API_KEY tanımlayın.');
    }
    return apiKey;
};

/**
 * TMDB API'ye istek yapar
 * @param {string} endpoint - API endpoint'i
 * @param {Object} params - Query parametreleri
 * @returns {Promise<Object>} API yanıtı
 */
const makeApiRequest = async (endpoint, params = {}) => {
    try {
        const apiKey = getApiKey();
        const url = new URL(`${TMDB_BASE_URL}${endpoint}`);

        // Parametreleri URL'ye ekle
        url.searchParams.append('api_key', apiKey);

        // Language parametresi params'tan gelmiyorsa varsayılan olarak tr-TR kullan
        const defaultLanguage = params.language || 'tr-TR';
        url.searchParams.append('language', defaultLanguage);

        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && key !== 'language') {
                url.searchParams.append(key, value.toString());
            }
        });

        const response = await fetch(url.toString());

        if (!response.ok) {
            throw new Error(`TMDB API Hatası: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('❌ TMDB API İstek Hatası:', error);
        throw error;
    }
};

/**
 * Türkçe karakterler içeriyor mu kontrol eder
 */
const containsTurkishChars = (text) => {
    const turkishChars = /[çğıöşüÇĞIİÖŞÜ]/;
    return turkishChars.test(text);
};

/**
 * İki başlığın benzerliğini hesaplar (0-1 arası)
 */
const calculateSimilarity = (title1, title2) => {
    const normalize = (s) => s.toLowerCase().replace(/[^a-z0-9ığüşöç]/gi, '').trim();
    const n1 = normalize(title1);
    const n2 = normalize(title2);

    if (n1 === n2) return 1.0;
    if (n1.includes(n2) || n2.includes(n1)) return 0.8;

    // Levenshtein benzeri basit kontrol
    const words1 = n1.split(' ').filter(w => w.length > 2);
    const words2 = n2.split(' ').filter(w => w.length > 2);
    const commonWords = words1.filter(w => words2.includes(w));

    if (commonWords.length === 0) return 0;
    return commonWords.length / Math.max(words1.length, words2.length);
};

/**
 * En iyi eşleşmeyi bulur
 */
const findBestMatch = (results, searchTitle) => {
    if (!results || results.length === 0) return null;

    // Her sonucu skorla
    const scored = results.map(movie => ({
        ...movie,
        score: calculateSimilarity(searchTitle, movie.title || '')
    }));

    // Skora göre sırala
    scored.sort((a, b) => b.score - a.score);

    // En az %40 benzerlik olmalı
    if (scored[0].score >= 0.4) {
        return scored[0];
    }

    return results[0]; // Fallback: ilk sonucu döndür
};

/**
 * TV/Dizi adı ve yılına göre TMDB'de arama yapar
 */
const searchTV = async (tvTitle, year = null) => {
    try {
        if (!tvTitle || tvTitle.trim() === '') {
            return null;
        }

        const cleanTitle = tvTitle.trim();
        const isTurkishTitle = containsTurkishChars(cleanTitle);

        // 1. ÖNCE TÜRKÇE DİLDE ARAMA
        if (isTurkishTitle) {
            let params = {
                query: cleanTitle,
                language: 'tr-TR'
            };

            if (year) {
                params.first_air_date_year = year;
            }

            let data = await makeApiRequest('/search/tv', params);

            if (data.results && data.results.length > 0) {
                const bestMatch = findBestMatch(data.results, cleanTitle);
                if (bestMatch) {
                    return bestMatch;
                }
            }

            if (year) {
                delete params.first_air_date_year;
                data = await makeApiRequest('/search/tv', params);
                if (data.results && data.results.length > 0) {
                    const bestMatch = findBestMatch(data.results, cleanTitle);
                    if (bestMatch) return bestMatch;
                }
            }
        }

        // 2. İNGİLİZCE ÇEVİRİ İLE ARAMA
        const englishTitle = translateToEnglish(cleanTitle);
        if (englishTitle !== cleanTitle) {
            let params = {
                query: englishTitle,
                language: 'en-US'
            };

            if (year) {
                params.first_air_date_year = year;
            }

            let data = await makeApiRequest('/search/tv', params);
            if (data.results && data.results.length > 0) {
                const bestMatch = findBestMatch(data.results, cleanTitle);
                if (bestMatch) return bestMatch;
            }

            if (year) {
                delete params.first_air_date_year;
                data = await makeApiRequest('/search/tv', params);
                if (data.results && data.results.length > 0) {
                    const bestMatch = findBestMatch(data.results, cleanTitle);
                    if (bestMatch) return bestMatch;
                }
            }
        }

        // 3. SON ÇARE: Genel arama
        let params = { query: cleanTitle };
        if (year) {
            params.first_air_date_year = year;
        }
        let data = await makeApiRequest('/search/tv', params);
        if (data.results && data.results.length > 0) {
            const bestMatch = findBestMatch(data.results, cleanTitle);
            if (bestMatch) return bestMatch;
            return data.results[0];
        }

        return null;
    } catch (error) {
        console.error(`❌ Dizi arama hatası (${tvTitle}):`, error);
        return null;
    }
};

/**
 * Film adı ve yılına göre TMDB'de arama yapar (geliştirilmiş - Türk filmleri için optimize)
 * @param {string} movieTitle - Film adı
 * @param {number|string} year - Film yılı (opsiyonel)
 * @param {string} contentType - 'film' veya 'dizi' (opsiyonel, default: 'film')
 * @returns {Promise<Object|null>} En iyi eşleşen film/dizi verisi veya null
 */
export const searchMovie = async (movieTitle, year = null, contentType = 'film') => {
    try {
        if (!movieTitle || movieTitle.trim() === '') {
            return null;
        }

        const cleanTitle = movieTitle.trim();
        const isTurkishTitle = containsTurkishChars(cleanTitle);

        // Dizi ise TV arama endpoint'ini kullan
        if (contentType === 'dizi') {
            return await searchTV(cleanTitle, year);
        }

        // 1. ÖNCE TÜRKÇE DİLDE ARAMA (Türk karakterler varsa veya Türk yapımları için)
        if (isTurkishTitle) {
            let params = {
                query: cleanTitle,
                language: 'tr-TR'
            };

            if (year) {
                params.year = year;
            }

            let data = await makeApiRequest('/search/movie', params);

            if (data.results && data.results.length > 0) {
                const bestMatch = findBestMatch(data.results, cleanTitle);
                if (bestMatch) {
                    return bestMatch;
                }
            }

            // Yıl olmadan tekrar dene
            if (year) {
                delete params.year;
                data = await makeApiRequest('/search/movie', params);

                if (data.results && data.results.length > 0) {
                    const bestMatch = findBestMatch(data.results, cleanTitle);
                    if (bestMatch) {
                        return bestMatch;
                    }
                }
            }
        }

        // 2. İNGİLİZCE ÇEVİRİ İLE ARAMA
        const englishTitle = translateToEnglish(cleanTitle);
        if (englishTitle !== cleanTitle) {
            let params = {
                query: englishTitle,
                language: 'en-US'
            };

            if (year) {
                params.year = year;
            }

            let data = await makeApiRequest('/search/movie', params);

            if (data.results && data.results.length > 0) {
                const bestMatch = findBestMatch(data.results, cleanTitle);
                if (bestMatch) {
                    return bestMatch;
                }
            }

            // Yıl olmadan dene
            if (year) {
                delete params.year;
                data = await makeApiRequest('/search/movie', params);

                if (data.results && data.results.length > 0) {
                    const bestMatch = findBestMatch(data.results, cleanTitle);
                    if (bestMatch) {
                        return bestMatch;
                    }
                }
            }
        }

        // 3. SON ÇARE: Orijinal ad ile multi-language arama
        let params = {
            query: cleanTitle
        };

        if (year) {
            params.year = year;
        }

        let data = await makeApiRequest('/search/movie', params);

        if (data.results && data.results.length > 0) {
            const bestMatch = findBestMatch(data.results, cleanTitle);
            if (bestMatch) {
                return bestMatch;
            }
            // Fallback: ilk sonucu döndür
            return data.results[0];
        }

        // Yıl olmadan son bir deneme
        if (year) {
            delete params.year;
            data = await makeApiRequest('/search/movie', params);

            if (data.results && data.results.length > 0) {
                const bestMatch = findBestMatch(data.results, cleanTitle);
                if (bestMatch) {
                    return bestMatch;
                }
                return data.results[0];
            }
        }

        return null;

    } catch (error) {
        console.error(`❌ Film arama hatası (${movieTitle}):`, error);
        return null;
    }
};

/**
 * TMDB poster yolunu tam URL'ye çevirir
 * @param {string} posterPath - TMDB'den gelen poster yolu
 * @param {boolean} highResolution - Yüksek çözünürlük için original kullan (default: false, w780 kullanır)
 * @returns {string} Tam poster URL'si veya default URL
 */
export const getPosterUrl = (posterPath, highResolution = false, lowResolution = false) => {
    if (!posterPath) {
        return DEFAULT_POSTER_URL;
    }
    let baseUrl;
    if (lowResolution) {
        baseUrl = TMDB_IMAGE_BASE_URL_LOW; // Blur placeholder için
    } else if (highResolution) {
        baseUrl = TMDB_IMAGE_BASE_URL_ORIGINAL; // Modal için
    } else {
        baseUrl = TMDB_IMAGE_BASE_URL; // Kart için optimize edilmiş (w500)
    }
    return `${baseUrl}${posterPath}`;
};

/**
 * Tek bir film/dizi için poster URL'si alır
 * @param {string} movieTitle - Film/Dizi adı
 * @param {number|string} year - Yıl (opsiyonel)
 * @param {string} contentType - 'film' veya 'dizi' (opsiyonel)
 * @param {boolean} highResolution - Yüksek çözünürlük için original kullan (default: false)
 * @returns {Promise<string>} Poster URL'si
 */
export const getMoviePoster = async (movieTitle, year = null, contentType = 'film', highResolution = false) => {
    try {
        const movie = await searchMovie(movieTitle, year, contentType);

        if (movie && movie.poster_path) {
            const posterUrl = getPosterUrl(movie.poster_path, highResolution);
            return posterUrl;
        } else {
            return DEFAULT_POSTER_URL;
        }
    } catch (error) {
        console.error(`❌ Poster alma hatası (${movieTitle}):`, error);
        return DEFAULT_POSTER_URL;
    }
};

/**
 * Birden fazla film/dizi için poster URL'lerini alır (yüksek çözünürlük)
 * @param {Array} movies - Film/Dizi listesi [{title: string, year?: number, contentType?: string}]
 * @param {boolean} highResolution - Yüksek çözünürlük için original kullan (default: false, w780 kullanır)
 * @returns {Promise<Array>} Poster URL'leri ile birlikte film/dizi listesi
 */
export const getMoviePosters = async (movies, highResolution = false) => {
    try {
        if (!Array.isArray(movies) || movies.length === 0) {
            return [];
        }

        // Paralel istekler için Promise.all kullan
        const posterPromises = movies.map(async (movie, index) => {
            try {
                const { title, year, contentType } = movie;
                const posterUrl = await getMoviePoster(title, year, contentType || 'film', highResolution);

                return {
                    ...movie,
                    posterUrl,
                    originalIndex: index
                };
            } catch (error) {
                console.error(`❌ Poster alma hatası (${movie.title}):`, error);
                return {
                    ...movie,
                    posterUrl: DEFAULT_POSTER_URL,
                    originalIndex: index
                };
            }
        });

        const results = await Promise.all(posterPromises);

        // Orijinal sıralamayı koru
        const sortedResults = results.sort((a, b) => a.originalIndex - b.originalIndex);
        const finalResults = sortedResults.map(({ originalIndex, ...movie }) => movie);

        return finalResults;

    } catch (error) {
        console.error('❌ Toplu poster alma hatası:', error);

        // Hata durumunda orijinal film listesini default posterlerle döndür
        return movies.map(movie => ({
            ...movie,
            posterUrl: DEFAULT_POSTER_URL
        }));
    }
};

/**
 * Film detaylarını ID ile alır (gelişmiş bilgiler için)
 * @param {number} movieId - TMDB film ID'si
 * @returns {Promise<Object|null>} Detaylı film bilgileri
 */
export const getMovieDetails = async (movieId) => {
    try {
        if (!movieId) {
            throw new Error('Film ID gerekli');
        }

        const data = await makeApiRequest(`/movie/${movieId}`);
        return data;
    } catch (error) {
        console.error(`❌ Film detay alma hatası (ID: ${movieId}):`, error);
        return null;
    }
};

/**
 * Gelişmiş arama: Birden fazla kritere göre film arar
 * @param {Object} searchCriteria - Arama kriterleri
 * @param {string} searchCriteria.title - Film adı
 * @param {number} searchCriteria.year - Yıl
 * @param {string} searchCriteria.genre - Tür (opsiyonel)
 * @returns {Promise<Array>} Bulunan filmler listesi
 */
export const advancedMovieSearch = async ({ title, year, genre }) => {
    try {
        const params = {
            query: title
        };

        if (year) params.year = year;

        const data = await makeApiRequest('/search/movie', params);

        let results = data.results || [];

        // Tür filtresi uygula (eğer belirtilmişse)
        if (genre && results.length > 0) {
            // İlk önce genre ID'lerini al
            const genreData = await makeApiRequest('/genre/movie/list');
            const genreMap = {};
            genreData.genres?.forEach(g => {
                genreMap[g.name.toLowerCase()] = g.id;
            });

            const targetGenreId = genreMap[genre.toLowerCase()];
            if (targetGenreId) {
                results = results.filter(movie =>
                    movie.genre_ids?.includes(targetGenreId)
                );
            }
        }

        return results;
    } catch (error) {
        console.error('❌ Gelişmiş arama hatası:', error);
        return [];
    }
};

/**
 * Hızlı poster URL çekme (cache ile)
 * @param {string} movieTitle - Film adı
 * @param {number} year - Film yılı
 * @returns {Promise<string>} Poster URL
 */
let posterCache = new Map();

export const getMoviePosterCached = async (movieTitle, year) => {
    const cacheKey = `${movieTitle}_${year || 'no_year'}`;

    if (posterCache.has(cacheKey)) {
        return posterCache.get(cacheKey);
    }

    const posterUrl = await getMoviePoster(movieTitle, year);
    posterCache.set(cacheKey, posterUrl);

    // Cache boyutunu sınırla (max 100 item)
    if (posterCache.size > 100) {
        const firstKey = posterCache.keys().next().value;
        posterCache.delete(firstKey);
    }

    return posterUrl;
};

/**
 * Film/dizi cast (oyuncu) bilgilerini getirir
 * @param {number} movieId - TMDB film/dizi ID'si
 * @param {string} contentType - 'film' veya 'dizi' (default: 'film')
 * @returns {Promise<Array>} Oyuncu listesi (en az başrol oyuncuları)
 */
export const getMovieCast = async (movieId, contentType = 'film') => {
    try {
        if (!movieId) {
            return [];
        }

        const endpoint = contentType === 'dizi' ? `/tv/${movieId}/credits` : `/movie/${movieId}/credits`;
        const data = await makeApiRequest(endpoint, { language: 'tr-TR' });

        if (!data || !data.cast) {
            return [];
        }

        // Cast listesini öncelik sırasına göre al (order özelliğine göre)
        // En az başrol oyuncuları (ilk 10-15 kişi genellikle başrol)
        const cast = data.cast
            .filter(actor => actor.known_for_department === 'Acting') // Sadece oyuncular
            .slice(0, 15) // İlk 15 oyuncu (başrol oyuncuları genellikle ilk sıralarda)
            .map(actor => actor.name);

        return cast;
    } catch (error) {
        console.error(`❌ Cast bilgisi alma hatası (ID: ${movieId}):`, error);
        return [];
    }
};

/**
 * Film/dizi detaylarını ve cast bilgilerini birlikte getirir
 * @param {string} movieTitle - Film/Dizi adı
 * @param {number|string} year - Yıl (opsiyonel)
 * @param {string} contentType - 'film' veya 'dizi' (opsiyonel)
 * @returns {Promise<Object|null>} Film detayları ve cast bilgileri
 */
export const getMovieDetailsWithCast = async (movieTitle, year = null, contentType = 'film') => {
    try {
        const movie = await searchMovie(movieTitle, year, contentType);
        
        if (!movie || !movie.id) {
            return null;
        }

        // Cast bilgilerini al
        const cast = await getMovieCast(movie.id, contentType);

        return {
            ...movie,
            cast,
            posterUrl: movie.poster_path ? getPosterUrl(movie.poster_path, true) : null, // Yüksek çözünürlük poster
            backdropUrl: movie.backdrop_path ? getPosterUrl(movie.backdrop_path, true) : null
        };
    } catch (error) {
        console.error(`❌ Film detay ve cast alma hatası (${movieTitle}):`, error);
        return null;
    }
};

/**
 * Film fragmanı (trailer) getirme
 * @param {string} movieTitle - Film adı
 * @param {number|string} year - Film yılı (opsiyonel)
 * @returns {Promise<Object|null>} Fragman bilgileri veya null
 */
export const getMovieTrailer = async (movieTitle, year = null) => {
    try {
        if (!movieTitle || movieTitle.trim() === '') {
            return null;
        }

        // Önce filmi bul
        const movie = await searchMovie(movieTitle, year);

        if (!movie) {
            return null;
        }

        const movieId = movie.id;

        // Filmin videolarını al
        const videosData = await makeApiRequest(`/movie/${movieId}/videos`, { language: 'en-US' });

        if (!videosData.results || videosData.results.length === 0) {
            return null;
        }

        // YouTube trailerlarını filtrele ve öncelik sırasına koy
        const trailers = videosData.results.filter(video =>
            video.site === 'YouTube' &&
            (video.type === 'Trailer' || video.type === 'Teaser' || video.type === 'Clip')
        ).sort((a, b) => {
            // Trailer > Teaser > Clip öncelik sırası
            const priority = { 'Trailer': 3, 'Teaser': 2, 'Clip': 1 };
            return (priority[b.type] || 0) - (priority[a.type] || 0);
        });

        if (trailers.length === 0) {
            return null;
        }

        // En uygun traileri al
        const trailer = trailers[0];
        const trailerData = {
            key: trailer.key,
            name: trailer.name,
            type: trailer.type,
            movieTitle: movie.title,
            movieYear: movie.release_date?.split('-')[0],
            url: `https://www.youtube.com/embed/${trailer.key}?autoplay=1&rel=0&showinfo=0`,
            thumbnailUrl: `https://img.youtube.com/vi/${trailer.key}/maxresdefault.jpg`,
            watchUrl: `https://www.youtube.com/watch?v=${trailer.key}`
        };

        return trailerData;

    } catch (error) {
        console.error(`❌ TMDB Fragman Hatası (${movieTitle}):`, error);
        return null;
    }
};

/**
 * Şu anda vizyonda olan filmleri getirir (Now Playing)
 * @param {number} page - Sayfa numarası (default: 1)
 * @param {string} region - Bölge kodu (default: 'TR' - Türkiye)
 * @returns {Promise<Object>} Vizyondaki filmler listesi
 */
export const getNowPlayingMovies = async (page = 1, region = 'TR') => {
    try {
        const data = await makeApiRequest('/movie/now_playing', {
            page,
            region,
            language: 'tr-TR'
        });

        // Filmleri normalize et ve poster URL'lerini ekle
        const movies = (data.results || []).map(movie => ({
            id: movie.id,
            title: movie.title,
            originalTitle: movie.original_title,
            overview: movie.overview,
            releaseDate: movie.release_date,
            year: movie.release_date ? parseInt(movie.release_date.split('-')[0]) : null,
            rating: movie.vote_average,
            voteCount: movie.vote_count,
            popularity: movie.popularity,
            posterUrl: movie.poster_path ? getPosterUrl(movie.poster_path, false) : DEFAULT_POSTER_URL,
            backdropUrl: movie.backdrop_path ? getPosterUrl(movie.backdrop_path, true) : null,
            genreIds: movie.genre_ids || [],
            contentType: 'film'
        }));

        return {
            movies,
            page: data.page || page,
            totalPages: data.total_pages || 1,
            totalResults: data.total_results || 0
        };
    } catch (error) {
        console.error('❌ Vizyondaki filmler alma hatası:', error);
        return {
            movies: [],
            page: 1,
            totalPages: 1,
            totalResults: 0
        };
    }
};

/**
 * Yakında çıkacak filmleri getirir (Upcoming)
 * @param {number} page - Sayfa numarası (default: 1)
 * @param {string} region - Bölge kodu (default: 'TR' - Türkiye)
 * @returns {Promise<Object>} Yakında çıkacak filmler listesi
 */
export const getUpcomingMovies = async (page = 1, region = 'TR') => {
    try {
        const data = await makeApiRequest('/movie/upcoming', {
            page,
            region,
            language: 'tr-TR'
        });

        // Filmleri normalize et ve poster URL'lerini ekle
        const movies = (data.results || []).map(movie => ({
            id: movie.id,
            title: movie.title,
            originalTitle: movie.original_title,
            overview: movie.overview,
            releaseDate: movie.release_date,
            year: movie.release_date ? parseInt(movie.release_date.split('-')[0]) : null,
            rating: movie.vote_average,
            voteCount: movie.vote_count,
            popularity: movie.popularity,
            posterUrl: movie.poster_path ? getPosterUrl(movie.poster_path, false) : DEFAULT_POSTER_URL,
            backdropUrl: movie.backdrop_path ? getPosterUrl(movie.backdrop_path, true) : null,
            genreIds: movie.genre_ids || [],
            contentType: 'film'
        }));

        return {
            movies,
            page: data.page || page,
            totalPages: data.total_pages || 1,
            totalResults: data.total_results || 0
        };
    } catch (error) {
        console.error('❌ Yakında çıkacak filmler alma hatası:', error);
        return {
            movies: [],
            page: 1,
            totalPages: 1,
            totalResults: 0
        };
    }
};

/**
 * Popüler filmleri getirir (Popular)
 * @param {number} page - Sayfa numarası (default: 1)
 * @param {string} region - Bölge kodu (default: 'TR' - Türkiye)
 * @returns {Promise<Object>} Popüler filmler listesi
 */
export const getPopularMovies = async (page = 1, region = 'TR') => {
    try {
        const data = await makeApiRequest('/movie/popular', {
            page,
            region,
            language: 'tr-TR'
        });

        // Filmleri normalize et ve poster URL'lerini ekle
        const movies = (data.results || []).map(movie => ({
            id: movie.id,
            title: movie.title,
            originalTitle: movie.original_title,
            overview: movie.overview,
            releaseDate: movie.release_date,
            year: movie.release_date ? parseInt(movie.release_date.split('-')[0]) : null,
            rating: movie.vote_average,
            voteCount: movie.vote_count,
            popularity: movie.popularity,
            posterUrl: movie.poster_path ? getPosterUrl(movie.poster_path, false) : DEFAULT_POSTER_URL,
            backdropUrl: movie.backdrop_path ? getPosterUrl(movie.backdrop_path, true) : null,
            genreIds: movie.genre_ids || [],
            contentType: 'film'
        }));

        return {
            movies,
            page: data.page || page,
            totalPages: data.total_pages || 1,
            totalResults: data.total_results || 0
        };
    } catch (error) {
        console.error('❌ Popüler filmler alma hatası:', error);
        return {
            movies: [],
            page: 1,
            totalPages: 1,
            totalResults: 0
        };
    }
};

/**
 * En yüksek puanlı filmleri getirir (Top Rated)
 * @param {number} page - Sayfa numarası (default: 1)
 * @param {string} region - Bölge kodu (default: 'TR' - Türkiye)
 * @returns {Promise<Object>} En yüksek puanlı filmler listesi
 */
export const getTopRatedMovies = async (page = 1, region = 'TR') => {
    try {
        const data = await makeApiRequest('/movie/top_rated', {
            page,
            region,
            language: 'tr-TR'
        });

        // Filmleri normalize et ve poster URL'lerini ekle
        const movies = (data.results || []).map(movie => ({
            id: movie.id,
            title: movie.title,
            originalTitle: movie.original_title,
            overview: movie.overview,
            releaseDate: movie.release_date,
            year: movie.release_date ? parseInt(movie.release_date.split('-')[0]) : null,
            rating: movie.vote_average,
            voteCount: movie.vote_count,
            popularity: movie.popularity,
            posterUrl: movie.poster_path ? getPosterUrl(movie.poster_path, false) : DEFAULT_POSTER_URL,
            backdropUrl: movie.backdrop_path ? getPosterUrl(movie.backdrop_path, true) : null,
            genreIds: movie.genre_ids || [],
            contentType: 'film'
        }));

        return {
            movies,
            page: data.page || page,
            totalPages: data.total_pages || 1,
            totalResults: data.total_results || 0
        };
    } catch (error) {
        console.error('❌ En yüksek puanlı filmler alma hatası:', error);
        return {
            movies: [],
            page: 1,
            totalPages: 1,
            totalResults: 0
        };
    }
};

/**
 * Son 30 gün içinde çıkan yeni filmleri getirir
 * @param {number} page - Sayfa numarası (default: 1)
 * @returns {Promise<Object>} Yeni filmler listesi
 */
export const getRecentMovies = async (page = 1) => {
    try {
        const today = new Date();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);

        const startDate = thirtyDaysAgo.toISOString().split('T')[0];
        const endDate = today.toISOString().split('T')[0];

        const data = await makeApiRequest('/discover/movie', {
            page,
            language: 'tr-TR',
            region: 'TR',
            'release_date.gte': startDate,
            'release_date.lte': endDate,
            sort_by: 'release_date.desc',
            'vote_count.gte': 10 // En az 10 oy almış olmalı
        });

        // Filmleri normalize et ve poster URL'lerini ekle
        const movies = (data.results || []).map(movie => ({
            id: movie.id,
            title: movie.title,
            originalTitle: movie.original_title,
            overview: movie.overview,
            releaseDate: movie.release_date,
            year: movie.release_date ? parseInt(movie.release_date.split('-')[0]) : null,
            rating: movie.vote_average,
            voteCount: movie.vote_count,
            popularity: movie.popularity,
            posterUrl: movie.poster_path ? getPosterUrl(movie.poster_path, false) : DEFAULT_POSTER_URL,
            backdropUrl: movie.backdrop_path ? getPosterUrl(movie.backdrop_path, true) : null,
            genreIds: movie.genre_ids || [],
            contentType: 'film'
        }));

        return {
            movies,
            page: data.page || page,
            totalPages: data.total_pages || 1,
            totalResults: data.total_results || 0
        };
    } catch (error) {
        console.error('❌ Yeni filmler alma hatası:', error);
        return {
            movies: [],
            page: 1,
            totalPages: 1,
            totalResults: 0
        };
    }
};

/**
 * Cache mekanizması - TMDb verilerini belirli süre boyunca cache'ler
 */
const cacheStore = new Map();

/**
 * Cache'i temizler
 */
export const clearCache = () => {
    cacheStore.clear();
    posterCache.clear();
    console.log('✅ TMDb cache temizlendi');
};

/**
 * Cache durumunu kontrol eder
 */
export const getCacheStatus = () => {
    const cacheEntries = Array.from(cacheStore.entries()).map(([key, value]) => ({
        key,
        age: Date.now() - value.timestamp,
        ageMinutes: Math.floor((Date.now() - value.timestamp) / (1000 * 60))
    }));

    return {
        totalEntries: cacheStore.size,
        posterCacheSize: posterCache.size,
        entries: cacheEntries
    };
};

// Varsayılan export
const tmdbService = {
    searchMovie,
    getPosterUrl,
    getMoviePoster,
    getMoviePosters,
    getMovieDetails,
    advancedMovieSearch,
    getMoviePosterCached,
    getMovieTrailer,
    getMovieCast,
    getMovieDetailsWithCast,
    getNowPlayingMovies,
    getUpcomingMovies,
    getPopularMovies,
    getTopRatedMovies,
    getRecentMovies,
    clearCache,
    getCacheStatus
};

export default tmdbService; 